import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import get_45profile_45global from "/app/middleware/getProfile.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  get_45profile_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-if-authenticated": () => import("/app/middleware/redirectIfAuthenticated.ts"),
  "redirect-to-login": () => import("/app/middleware/redirectToLogin.ts"),
  "redirect-to-sub": () => import("/app/middleware/redirectToSub.ts")
}